import React from 'react';
import PageHeader from '../../components/PageHeader';

const SettingsListHeader = () => <PageHeader title="Settings" />;

export default SettingsListHeader;
